(function (w, d) {
	if (w.location.pathname !== '/') return;
	const throttleTime = 200;
	const logo = d.querySelector('.js-logo-infinity');

	updateScroll = throttle(updateScroll, throttleTime);
	updateResize = throttle(updateResize, throttleTime);

	setListeners();
	updateResize();

	function updateScroll() {
		const position = w.scrollY + 50;
		const numbers = d.querySelector('.js-numbers');
		const covers = d.querySelector('.js-covers');
		const features = d.querySelector('.js-features');
		const industries = d.querySelector('.js-industries');
		const media = d.querySelector('.js-media');

		logo.style.fill = '#8fb840';

		if (
			w.innerWidth > 960
			&& (isSectionChanged(position, features, industries)
			|| isSectionChanged(position, numbers, covers)
			|| isSectionChanged(position, media))
		) {
			logo.style.fill = '#021d1e';
		}
		if (w.innerWidth > 960 && isSectionChanged(position, covers, features)) {
			logo.style.fill = '#fff';
		}
	}

	function updateResize() {
		logo.classList.toggle('logo__infinity_fixed', w.innerWidth > 960);
	}

	function setListeners() {
		w.addEventListener('scroll', updateScroll);
		w.addEventListener('resize', updateResize);
	}

	function throttle(func, ms) {
		let isThrottled = false,
			savedArgs,
			savedThis;

		function wrapper() {
			if (isThrottled) {
				savedArgs = arguments;
				savedThis = this;
				return;
			}

			func.apply(this, arguments);

			isThrottled = true;

			setTimeout(function() {
				isThrottled = false;
				if (savedArgs) {
					wrapper.apply(savedThis, savedArgs);
					savedArgs = savedThis = null;
				}
			}, ms);
		}

		return wrapper;
	}

	function isSectionChanged(scroll, a, b) {
		if (b !== undefined) {
			return scroll > a.offsetTop && scroll < b.offsetTop;
		}
		return scroll > a.offsetTop;
	}
})(window, document);
